import { useFormikContext } from "formik";
import moment from "moment";
import React from "react";

import { CurrentFinanceYear } from "../../../../config/app-constants";
import { IAnyOtherAssets } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import { DateTimePicker, FormField, NumericInputField, TextInputField } from "../../../fields";

const OAAssetDetailsForm: React.FC = () => {
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<IAnyOtherAssets>();

  return (
    <section className="mb-5">
      <FormField label="Asset Description" isRequired={true} sm={4}>
        <TextInputField
          name="Description"
          value={values.Description}
          onChange={(value) => {
            setFieldValue("Description", value);
          }}
          onBlur={() => {
            handleBlur("Description");
            setFieldValue("Description", values.Description.trim());
          }}
          isInvalid={Boolean(errors.Description) && touched.Description}
          errorMsg={errors.Description}
          note="Example: Sale of Shares or Sale of Gold"
        />
      </FormField>

      <FormField label="Date of Purchase" isRequired={true} sm={4}>
        <DateTimePicker
          name="PurchaseDate"
          placeholder="DD/MM/YYYY"
          value={values.PurchaseDate ? moment(values.PurchaseDate).toDate() : ""}
          onChange={(date) => {
            if (date) {
              const _date = UtilService.convertToStandardDateFormat(date);
              setFieldValue("PurchaseDate", _date);
            } else {
              setFieldValue("PurchaseDate", "");
            }
          }}
          onBlur={handleBlur("PurchaseDate")}
          minDate={undefined}
          maxDate={
            values?.SaleDate
              ? moment(values.SaleDate).toDate()
              : moment(CurrentFinanceYear).toDate()
          }
          isInvalid={Boolean(errors.PurchaseDate) && touched.PurchaseDate}
          errorMsg={errors.PurchaseDate}
          isClearable={true}
        />
      </FormField>

      <FormField label="Date of Sale" isRequired={true} sm={4}>
        <DateTimePicker
          name="SaleDate"
          placeholder="DD/MM/YYYY"
          value={values.SaleDate ? moment(values.SaleDate).toDate() : ""}
          onChange={(date) => {
            if (date) {
              const _date = UtilService.convertToStandardDateFormat(date);
              setFieldValue("SaleDate", _date);
            } else {
              setFieldValue("SaleDate", "");
            }
          }}
          onBlur={handleBlur("SaleDate")}
          minDate={
            values?.PurchaseDate
              ? moment(values.PurchaseDate).toDate()
              : moment(CurrentFinanceYear).toDate()
          }
          maxDate={moment(CurrentFinanceYear).toDate()}
          isInvalid={Boolean(errors.SaleDate) && touched.SaleDate}
          errorMsg={errors.SaleDate}
          isClearable={true}
        />
      </FormField>

      <FormField label="Total Purchase Price" isRequired={true} sm={4}>
        <NumericInputField
          showLeftIcon={true}
          placeholder=""
          name="TotalPurchasePrice"
          value={values.TotalPurchasePrice}
          onChange={(value) => setFieldValue("TotalPurchasePrice", value)}
          onBlur={handleBlur("TotalPurchasePrice")}
          isInvalid={Boolean(errors.TotalPurchasePrice) && touched.TotalPurchasePrice}
          errorMsg={errors.TotalPurchasePrice}
        />
      </FormField>

      <FormField label="Total Sale Price" isRequired={true} sm={4}>
        <NumericInputField
          showLeftIcon={true}
          placeholder=""
          name="TotalSalePrice"
          value={values.TotalSalePrice}
          onChange={(value) => setFieldValue("TotalSalePrice", value)}
          onBlur={handleBlur("TotalSalePrice")}
          isInvalid={Boolean(errors.TotalSalePrice) && touched.TotalSalePrice}
          errorMsg={errors.TotalSalePrice}
        />
      </FormField>
    </section>
  );
};

export default OAAssetDetailsForm;
